type AssignmentWithTeacherName = {
  teacherName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  teacherFirstName?: string | null;
  teacherLastName?: string | null;
  fullName?: string | null;
  name?: string | null;
  teacher?: {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    name?: string | null;
  } | null;
};

export const teacherAssignmentName = (assignment?: AssignmentWithTeacherName | null): string => {
  if (!assignment) return "";
  return (
    assignment.teacherName ||
    assignment.teacher?.fullName ||
    assignment.teacher?.name ||
    [assignment.teacher?.firstName, assignment.teacher?.lastName].filter(Boolean).join(" ").trim() ||
    [assignment.teacherFirstName, assignment.teacherLastName].filter(Boolean).join(" ").trim() ||
    [assignment.firstName, assignment.lastName].filter(Boolean).join(" ").trim() ||
    assignment.fullName ||
    assignment.name ||
    ""
  );
};
